__turbopack_context__.v({
  "bulletPoint": "_6z7R-a_bulletPoint",
  "bulletPoints": "_6z7R-a_bulletPoints",
  "card": "_6z7R-a_card",
  "content": "_6z7R-a_content",
  "inputValue": "_6z7R-a_inputValue",
  "radioRow": "_6z7R-a_radioRow",
  "title": "_6z7R-a_title",
  "titleGroup": "_6z7R-a_titleGroup",
});
